export default [
    "kz",
    "en",
    "ru"
]